module.exports = __webpack_public_path__ + "img/product_112.e72ee78.webp";